import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import { getLoginEmpresasById } from "../services/EmpresaServices";
import { getMe } from '../services/UserServices';
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const initialToken = localStorage.getItem("paneltoken");
  const [token, setToken] = useState(initialToken);
  const [isAuthenticated, setIsAuthenticated] = useState(!!initialToken);
  const [isLoadEmpresa, setIsLoadEmpresa] = useState(false);

  const [user, setUser] = useState();
  const [empresaData, setEmpresaData] = useState();

  useEffect(() => {
    const bc = new BroadcastChannel("auth_channel");

    bc.onmessage = (event) => {
      if (event.data.type === "logout") {
        logout();
      }
    };

    return () => bc.close();
  }, [navigate]);

  useEffect(() => {
    getEmpresaData();
  }, []);

  const getEmpresaData = async () => {
    try {
      if (!empresaData) {
        const empresaResponse = await getLoginEmpresasById(1);
        setEmpresaData(empresaResponse);
        localStorage.setItem("panelempresaData", JSON.stringify(empresaResponse));
      }
    } catch (error) {
      console.error("Error al obtener los datos de la empresa:", error);
    }
  };

  const login = async () => {
    const accessToken = localStorage.getItem("paneltoken");
    if (accessToken) {
      try {
        jwtDecode(accessToken);
        setToken(accessToken);
        setIsAuthenticated(true);
        const bc = new BroadcastChannel("auth_channel");
        bc.postMessage({ type: "login" });

        const userMe = await getMe();
        setUser(userMe);
        localStorage.setItem("paneluserData", JSON.stringify(userMe));


        try {
          const res = await getLoginEmpresasById(1);
          if (res && res.nombre_sitio) {
            localStorage.setItem("panelempresaNombre", res.nombre_sitio);
            localStorage.setItem("panelempresaData", JSON.stringify(res));
            setIsLoadEmpresa(true);
            setEmpresaData(res);
          } else {
            console.warn("No hay datos de empresa disponibles");
          }
        } catch (empresaError) {
          console.warn("Error al obtener datos de empresa:", empresaError);
        }

      } catch (error) {
        console.error("Error al iniciar sesión:", error);
        logout();
      }
    }
  };


  const logout = () => {
    setToken(null);
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem("paneltoken");
    localStorage.removeItem("panelempresaData");
    localStorage.removeItem("panelempresaNombre");
    localStorage.removeItem("paneluserData");

    const bc = new BroadcastChannel("auth_channel");
    bc.postMessage({ type: "logout" });

  };

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, login, logout, isLoadEmpresa, setIsLoadEmpresa, empresaData, user }}>
      {children}
    </AuthContext.Provider>
  );
};
